export const ORGANIZATION_ORIGIN = {
  NORTH_AMERICA: 'northAmerica',
  EUROPE: 'europe',
  EASTERN_EUROPE: 'easternEurope',
  ASIA_PACIFIC: 'asiaPacific',
  SOUTH_AMERICA: 'southAmerica',
  MIDDLE_EAST: 'middleEast',
  AFRICA: 'africa',
}

export const ORGANIZATION_ORIGIN_VALUES = [
  ORGANIZATION_ORIGIN.NORTH_AMERICA,
  ORGANIZATION_ORIGIN.EUROPE,
  ORGANIZATION_ORIGIN.EASTERN_EUROPE,
  ORGANIZATION_ORIGIN.ASIA_PACIFIC,
  ORGANIZATION_ORIGIN.SOUTH_AMERICA,
  ORGANIZATION_ORIGIN.MIDDLE_EAST,
  ORGANIZATION_ORIGIN.AFRICA,
]

const ORIGIN_SEARCH_ALIASES = {
  'north america': ORGANIZATION_ORIGIN.NORTH_AMERICA,
  europe: ORGANIZATION_ORIGIN.EUROPE,
  'eastern europe': ORGANIZATION_ORIGIN.EASTERN_EUROPE,
  'asia pacific': ORGANIZATION_ORIGIN.ASIA_PACIFIC,
  'south america': ORGANIZATION_ORIGIN.SOUTH_AMERICA,
  'middle east': ORGANIZATION_ORIGIN.MIDDLE_EAST,
  africa: ORGANIZATION_ORIGIN.AFRICA,
}

function normalizeSearchText(value) {
  return (value ?? '')
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^\w]+/g, ' ')
    .trim()
}

export function mapOriginSearchAlias(value) {
  const normalized = normalizeSearchText(value)
  if (!normalized) return value?.toString?.() ?? ''
  return ORIGIN_SEARCH_ALIASES[normalized] ?? value?.toString?.() ?? ''
}
